import Avatar from "@pathwright/ui/src/components/avatar/Avatar"
import Button from "@pathwright/ui/src/components/button/Button"
import DropdownItem from "@pathwright/ui/src/components/dropdown/DropdownItem"
import DropdownMenu from "@pathwright/ui/src/components/dropdown/DropdownMenu"
import DropdownTrigger from "@pathwright/ui/src/components/dropdown/DropdownTrigger"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import withTranslate from "@pathwright/ux/src/components/lng/withTranslate"
import ChangelogToggle from "@pathwright/features/src/modules/changelog/ChangelogToggle"
import useHomeActiveEntries from "@pathwright/features/src/modules/home/useHomeActiveEntries"
import InboxNavigatorIndicator from "@pathwright/features/src/modules/inbox/navigator/InboxNavigatorIndicator"
import { getGroupSubscriptionLinkProps } from "@pathwright/features/src/modules/mentor-group/utils"
import NotificationsIndicator from "@pathwright/features/src/modules/notifications/NotificationsIndicator"
import useUnifiedHomePermissions from "@pathwright/features/src/modules/unified-home/view-permission/useUnifiedHomePermissions"
import { withUserCommunity } from "@pathwright/features/src/modules/user/UserCommunityContext"
import { urls } from "lib/core/utils"
import { useLocation } from "react-router-dom"
import "./styles/NavbarUser.css"

const HomeDropdownItem = ({ user, tc }) => {
  const { path: homePath } = useHomeActiveEntries()

  return (
    <DropdownItem icon="homepage-learn" to={homePath}>
      {!!user && (
        <Avatar
          style={{ marginRight: 2.3 }}
          user={user}
          size={16}
          sizeUnit="px"
        />
      )}
      {`${tc("Home")}`}
    </DropdownItem>
  )
}

const NavbarUser = function ({
  isAuthenticated,
  user,
  showTeach,
  showDesign,
  buttonStyle,
  communityGroupSubscriptions,
  communityGroupWithActiveSubscription,
  // Using both active and inactive group subscriptions which should
  // catch all cases.
  activeCommunityGroupSubscription,
  inactiveCommunityGroupSubscription,
  t,
  tc
}) {
  const location = useLocation()
  const canViewUnifiedHome = useUnifiedHomePermissions().canView
  // Permit the user to open the home augmentation settings when school
  // has unified home feature and user is viewing Home Screen (the augmenation
  // currently only works there).
  const settingsRoute =
    canViewUnifiedHome && location.pathname.startsWith("/home/")
      ? "/home/?panel=/settings"
      : urls.modalRoute("/manage/profile/")

  if (isAuthenticated) {
    const hasInactiveGroupSubscription =
      communityGroupSubscriptions.length > 0 &&
      !communityGroupWithActiveSubscription
    return (
      <div className="NavbarUser">
        <DropdownTrigger
          className="NavbarUser__dropdown"
          renderDropdown={() => {
            return (
              <DropdownMenu closeOnClick={true}>
                <HomeDropdownItem user={user} tc={tc} />
                <DropdownItem
                  icon="gear"
                  label={t(["dashboard.header.your_settings", "Your settings"])}
                  to={settingsRoute}
                />
                {communityGroupSubscriptions.length > 0 ? (
                  <DropdownItem
                    icon="credit-card"
                    label={tc("Manage subscription")}
                    {...getGroupSubscriptionLinkProps(
                      activeCommunityGroupSubscription ||
                        inactiveCommunityGroupSubscription
                    )}
                  />
                ) : null}
                <DropdownItem
                  icon="external-link"
                  label={t("nav.navbar_user.sign_out")}
                  to="/auth/sign-out/"
                />
              </DropdownMenu>
            )
          }}
        >
          <Button {...Object.assign({}, buttonStyle)}>
            <Avatar user={user} size="25px" /> <Pathicon icon="chevron-down" />
            {/* {hasInactiveGroupSubscription ? <StyledAvatarDot /> : null} */}
          </Button>
        </DropdownTrigger>
        <InboxNavigatorIndicator />
        <NotificationsIndicator />
        <ChangelogToggle />
        {/* <NotificationIndicator buttonStyle={buttonStyle} /> */}
      </div>
    )
  } else {
    return (
      <Button
        {...Object.assign(
          { className: "NavbarUser__signin NavbarUser__signin" },
          buttonStyle,
          {
            to: `/auth/sign-in?next=${
              window.location.pathname + window.location.search
            }`
          }
        )}
      >
        <span>{t("nav.navbar_user.sign_in")}</span>
      </Button>
    )
  }
}

NavbarUser.displayName = "NavbarUser"

export default withTranslate(withUserCommunity(NavbarUser))
